import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import CommonPage from '@/components/CommonPage';
import CommonPageOld from '@/components/CommonPageOld';
import CommonPostDetail from '@/components/CommonPostDetail';
import DiscussionAddForm from '@/components/DiscussionAddForm';
import AttachmentAddForm from '@/components/AttachmentAddForm';
import AddEditMenu from '@/components/AddEditMenu';
import EventAddForm from '@/components/EventAddForm';
//import UserList from '@/components/UserList';
import AddCalendarKey from '@/components/AddCalendarKey';
import AddAttachmentGroup from '@/components/AddAttachmentGroup';
import ListCalendarKey from '@/components/ListCalendarKey';
import ListAttachmentGroup from '@/components/ListAttachmentGroup';

import UserList from '@/components/backend/user/ListUser';
import ChangeProfile from '@/components/backend/user/ChangeProfile';
import AddUpdateUsers from '@/components/backend/user/AddUpdateUsers';
import HRDragView from '@/components/backend/user/HRDragView';

import ListROReversalRequest from '@/components/Forms/ROReversalRequest/ListROReversalRequest';
import AddUpdateROReversalRequest from '@/components/Forms/ROReversalRequest/AddUpdateROReversalRequest';

import ListSuspendedROReview from '@/components/Forms/SuspendedROReview/ListSuspendedROReview';
import AddUpdateSuspendedROReview from '@/components/Forms/SuspendedROReview/AddUpdateSuspendedROReview';

import ListTrainingRequest from '@/components/Forms/TrainingRequestMaster/ListTrainingRequest';
import AddUpdateTrainingRequest from '@/components/Forms/TrainingRequestMaster/AddUpdateTrainingRequest';
import ListTechTime from '@/components/Forms/TechTimeMaster/ListTechTime';
import AddUpdateTechTime from '@/components/Forms/TechTimeMaster/AddUpdateTechTime';

import ListSpanishTechTime from '@/components/Forms/TechTimeMaster/ListSpanishTechTime';
import AddUpdateSpanishTechTime from '@/components/Forms/TechTimeMaster/AddUpdateSpanishTechTime';

import ListSupportStaff from '@/components/Forms/SupportStaffMaster/ListSupportStaff';
import AddUpdateSupportStaff from '@/components/Forms/SupportStaffMaster/AddUpdateSupportStaff';

import ListTechicianShiftChange from '@/components/Forms/TechicianShiftChangeMaster/ListTechicianShiftChange';
import AddUpdateTechicianShiftChange from '@/components/Forms/TechicianShiftChangeMaster/AddUpdateTechicianShiftChange';

import ListTechnicianTeamDepartmentChanges from '@/components/Forms/TechicianTeamDepartmentChangeMaster/ListTechnicianTeamDepartmentChanges';
import AddUpdateTechnicianTeamDepartmentChanges from '@/components/Forms/TechicianTeamDepartmentChangeMaster/AddUpdateTechnicianTeamDepartmentChanges';

import ListTechnicianUniform from '@/components/Forms/TechnicianUniformMaster/ListTechnicianUniform';
import AddUpdateTechnicianUniform from '@/components/Forms/TechnicianUniformMaster/AddUpdateTechnicianUniform';

import ListOfficeSupplier from '@/components/Forms/OfficeSupplier/ListOfficeSupplier';
import AddUpdateOfficeSupplier from '@/components/Forms/OfficeSupplier/AddUpdateOfficeSupplier';

import ListVendor from '@/components/Forms/VendorMaster/ListVendor';
import AddUpdateVendor from '@/components/Forms/VendorMaster/AddUpdateVendor';

import ListFormEmailManager from '@/components/Forms/FormEmailManager/ListFormEmailManager';
import AddUpdateFormEmailManager from '@/components/Forms/FormEmailManager/AddUpdateFormEmailManager';

import ListLaborReview from '@/components/Forms/LaborReview/ListLaborReview';
import AddUpdateLaborReview from '@/components/Forms/LaborReview/AddUpdateLaborReview';

import ListPPEOrderSupplies from '@/components/Forms/PPEOrderSupplies/ListPPEOrderSupplies';
import AddUpdatePPEOrderSupplies from '@/components/Forms/PPEOrderSupplies/AddUpdatePPEOrderSupplies';

import ListSubletReversalForm from '@/components/Forms/SubletReversalForm/ListSubletReversalForm';
import AddUpdateSubletReversalForm from '@/components/Forms/SubletReversalForm/AddUpdateSubletReversalForm';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/user/list',
            name: 'UserList',
            component: UserList,
        },
        {
            path: '/changeprofile',
            name: 'ChangeProfile',
            component: ChangeProfile,
        },
        {
            path: '/updateusers/:id',
            name: 'AddUpdateUsers',
            component: AddUpdateUsers,
        },
        {
            path: '/roreversal/list',
            name: 'ListROReversalRequest',
            component: ListROReversalRequest,
        },
        {
            path: '/roreversal/add',
            name: 'AddUpdateROReversalRequest',
            component: AddUpdateROReversalRequest,
        },
        {
            path: '/roreversal/edit/:id',
            name: 'UpdateROReversalRequest',
            component: AddUpdateROReversalRequest,
        },
        {
            path: '/subletreversal/list',
            name: 'ListSubletReversalForm',
            component: ListSubletReversalForm,
        },
        {
            path: '/subletreversal/add',
            name: 'AddUpdateSubletReversalForm',
            component: AddUpdateSubletReversalForm,
        },
        {
            path: '/subletreversal/edit/:id',
            name: 'UpdateSubletReversalForm',
            component: AddUpdateSubletReversalForm,
        },
        {
            path: '/suspendedro/list',
            name: 'ListSuspendedROReview',
            component: ListSuspendedROReview,
        },
        {
            path: '/suspendedro/add',
            name: 'AddUpdateSuspendedROReview',
            component: AddUpdateSuspendedROReview,
        },
        {
            path: '/suspendedro/edit/:id',
            name: 'UpdateSuspendedROReview',
            component: AddUpdateSuspendedROReview,
        },
        {
            path: '/techtime/list',
            name: 'ListTechTime',
            component: ListTechTime,
        },
        {
            path: '/techtime/add',
            name: 'AddUpdateTechTime',
            component: AddUpdateTechTime,
        },
        {
            path: '/updatetechtime/:id',
            name: 'UpdateTechTime',
            component: AddUpdateTechTime,
        },
        {
            path: '/training/request/list',
            name: 'ListTrainingRequest',
            component: ListTrainingRequest,
        },
        {
            path: '/training/request/add',
            name: 'AddUpdateTrainingRequest',
            component: AddUpdateTrainingRequest,
        },
        {
            path: '/training/request/edit/:id',
            name: 'UpdateTrainingRequest',
            component: AddUpdateTrainingRequest,
        },
        {
            path: '/techtime/spanish/list',
            name: 'ListSpanishTechTime',
            component: ListSpanishTechTime,
        },
        {
            path: '/techtime/spanish/add',
            name: 'AddUpdateSpanishTechTime',
            component: AddUpdateSpanishTechTime,
        },
        {
            path: '/dayforace/time/list',
            name: 'ListSupportStaff',
            component: ListSupportStaff,
        },
        {
            path: '/dayforace/time/add',
            name: 'AddUpdateSupportStaff',
            component: AddUpdateSupportStaff,
        },
        {
            path: '/updatesupportstafftime/:id',
            name: 'UpdateSupportStaff',
            component: AddUpdateSupportStaff,
        },
        {
            path: '/technician/shift/list',
            name: 'ListTechicianShiftChange',
            component: ListTechicianShiftChange,
        },
        {
            path: '/technician/shift/add',
            name: 'AddUpdateTechicianShiftChange',
            component: AddUpdateTechicianShiftChange,
        },
        {
            path: '/updateshift/:id',
            name: 'UpdateTechicianShiftChange',
            component: AddUpdateTechicianShiftChange,
        },
        {
            path: '/technician/team/department/list',
            name: 'ListTechnicianTeamDepartmentChanges',
            component: ListTechnicianTeamDepartmentChanges,
        },
        {
            path: '/technician/team/department/add',
            name: 'AddUpdateTechnicianTeamDepartmentChanges',
            component: AddUpdateTechnicianTeamDepartmentChanges,
        },
        {
            path: '/updatetechteamdepartment/:id',
            name: 'UpdateTechnicianTeamDepartmentChanges',
            component: AddUpdateTechnicianTeamDepartmentChanges,
        },
        {
            path: '/technician/uniform/list',
            name: 'ListTechnicianUniform',
            component: ListTechnicianUniform,
        },
        {
            path: '/technician/uniform/add',
            name: 'AddUpdateTechnicianUniform',
            component: AddUpdateTechnicianUniform,
        },
        {
            path: '/office/supplier/list',
            name: 'ListOfficeSupplier',
            component: ListOfficeSupplier,
        },
        {
            path: '/office/supplier/add',
            name: 'AddUpdateOfficeSupplier',
            component: AddUpdateOfficeSupplier,
        },
        {
            path: '/office/supplier/edit/:id',
            name: 'UpdateOfficeSupplier',
            component: AddUpdateOfficeSupplier,
        },
        {
            path: '/vendor/item/list',
            name: 'ListVendor',
            component: ListVendor,
        },
        {
            path: '/vendor/item/add',
            name: 'AddUpdateVendor',
            component: AddUpdateVendor,
        },
        {
            path: '/vendor/item/edit/:id',
            name: 'UpdateVendor',
            component: AddUpdateVendor,
        },
        {
            path: '/form/email/manager/list',
            name: 'ListFormEmailManager',
            component: ListFormEmailManager,
        },
        {
            path: '/form/email/manager/add',
            name: 'AddUpdateFormEmailManager',
            component: AddUpdateFormEmailManager,
        },
        {
            path: '/form/email/manager/edit/:id',
            name: 'UpdateFormEmailManager',
            component: AddUpdateFormEmailManager,
        },
        {
            path: '/labor/review/list',
            name: 'ListLaborReview',
            component: ListLaborReview,
        },
        {
            path: '/labor/review/add',
            name: 'AddUpdateLaborReview',
            component: AddUpdateLaborReview,
        },
        {
            path: '/labor/review/edit/:id',
            name: 'UpdateLaborReview',
            component: AddUpdateLaborReview,
        },
        {
            path: '/ppe/order/supplies/list',
            name: 'ListPPEOrderSupplies',
            component: ListPPEOrderSupplies,
        },
        {
            path: '/ppe/order/supplies/add',
            name: 'AddUpdatePPEOrderSupplies',
            component: AddUpdatePPEOrderSupplies,
        },
        {
            path: '/ppe/order/supplies/edit/:id',
            name: 'UpdatePPEOrderSupplies',
            component: AddUpdatePPEOrderSupplies,
        },
        {
            path: '/hrdragview',
            name: 'HRDragView',
            component: HRDragView,
        },
        {
            path: '/:type',
            name: 'CommonPage',
            component: CommonPage
        },{
            path: '/:type/test',
            name: 'CommonPageOld',
            component: CommonPageOld
        },
        {
            path: '/:type/view',
            name: 'CommonPostDetail',
            component: CommonPostDetail
        },
        {
            path: '/:type/add_post',
            name: 'DiscussionAddForm',
            component: DiscussionAddForm
        },
        {
            path: '/:type/edit_post/:id',
            name: 'DiscussionEditForm',
            component: DiscussionAddForm
        },
        {
            path: '/:type/add_document',
            name: 'AttachmentAddForm',
            component: AttachmentAddForm
        },
        {
            path: '/:type/edit_document/:id',
            name: 'AttachmentEditForm',
            component: AttachmentAddForm
        },
        {
            path: '/:type/add_date',
            name: 'EventAddForm',
            component: EventAddForm
        },
        {
            path: '/:type/edit_date/:id',
            name: 'EventEditForm',
            component: EventAddForm
        },
        {
            path: '/menu/add-edit-menu',
            name: 'AddEditMenu',
            component: AddEditMenu
        },
        /*{
            path: '/user/list',
            name: 'UserList',
            component: UserList
        },*/
        {
            path: '/key/list',
            name: 'ListCalendarKey',
            component: ListCalendarKey
        },
        {
            path: '/key/add',
            name: 'AddCalendarKey',
            component: AddCalendarKey
        },
        {
            path: '/key/edit/:id',
            name: 'EditCalendarKey',
            component: AddCalendarKey
        },
        {
            path: '/attachment-group/list',
            name: 'ListAttachmentGroup',
            component: ListAttachmentGroup
        },
        {
            path: '/attachment-group/add',
            name: 'AddAttachmentGroup',
            component: AddAttachmentGroup
        },
        {
            path: '/attachment-group/edit/:id',
            name: 'EditAttachmentGroup',
            component: AddAttachmentGroup
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js